const permissions = {
  None: "No special permission required",
  GlobalAdmin: "AMP Global Admin",
  AdminOrganisationOnly: "Admin Organisation Only",
  ManageOrganisations: "Manage Organisations",
  ViewLogs: "View Logs",
  OrganisationAdmin: "Organisation Admin",
};
export default permissions;
